'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function checkAccess(module, user) {
    if (!module.accessRules) return true;

    for (var ruleIndex in module.accessRules) {
        if (!module.accessRules[ruleIndex](user)) return false;
    }

    return true;
};

// BizRules
function userInGroup(groups) {
    return function (user) {
        var list = (typeof groups === 'undefined' ? 'undefined' : _typeof(groups)) !== 'object' ? [groups] : groups;
        for (var groupIndex in list) {
            var group = list[groupIndex];
            if (user.groups && user.groups.indexOf(group) !== -1) {
                return true;
            }
        }
        return false;
    };
}

function hasScope(scope) {
    return function (user) {
        if (!scope) return false;

        var scopeParts = typeof scope == 'string' ? scope.split(' ') : scope;
        var userScope = getScopeObject(user.scope || '');

        // If no Scope - no access
        if (Object.keys(userScope).length == 0) return false;

        // All Scope? ACCESS GRANTED
        if (userScope.all) return true;

        for (var partIndex in scopeParts) {
            var parts = scopeParts[partIndex].split(':');
            var scopeSpace = parts[0];
            var scopeValue = parts.length == 2 ? parts[1] : 'all';

            // Check hasScope by Name
            if (!userScope[scopeSpace]) return false;
            // Check if all in scopeSpace
            if (userScope[scopeSpace].indexOf('all') !== -1) continue;
            // Check scopeValue in space
            if (userScope[scopeSpace].indexOf(scopeValue) === -1) return false;
        }

        return true;
    };
}

function getScopeObject(scopeString) {
    var scopes = scopeString.split(' ');
    var scope = {};

    scopes.forEach(function (entry) {
        var parts = entry.split(':');
        var scopeSpace = parts[0];
        var scopeValue = parts.length == 2 ? parts[1] : 'all';

        scope[scopeSpace] = scope[scopeSpace] ? scope[scopeSpace] : [];
        scope[scopeSpace].push(scopeValue);
    });

    return scope;
}

exports.checkAccess = checkAccess;
exports.userInGroup = userInGroup;
exports.hasScope = hasScope;
//# sourceMappingURL=access.js.map


//////////////////
// WEBPACK FOOTER
// ./~/perx-uikit/dist/helpers/access.js
// module id = 609
// module chunks = 5